import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { colors } from '../../components/Theme/WebTheme';

const ElevatedButton = React.forwardRef((props, ref) => {
    const { children, disabled, ...rest } = props;

    const [colorBg, setColorBg] = useState(colors.MAIN_COLOR);
    const [colorBgHover, setColorBgHover] = useState(colors.GREEN);
    const [colorText, setColorText] = useState(colors.BLACK);

    useEffect(() => {
        const { type } = props;
        if (disabled) {
            setColorBg(colors.GREY);
            setColorBgHover(colors.GREY);
            setColorText(colors.WHITE);
        } else {
            if (type === "submit") {
                setColorBg(colors.MAIN_COLOR);
                setColorBgHover(colors.GREEN);
                setColorText(colors.WHITE);
            } else if (type === "add") {
                setColorBg(colors.BLUE);
                setColorBgHover(colors.BLUE);
                setColorText(colors.WHITE);
            } else if (type === "error") {
                setColorBg(colors.RED);
                setColorBgHover(colors.RED);
                setColorText(colors.WHITE);
            } else if (type === "success") {
                setColorBg(colors.GREEN);
                setColorBgHover(colors.GREEN);
                setColorText(colors.WHITE);
            } else if (type === "edit") {
                setColorBg(colors.ORANGE);
                setColorBgHover(colors.ORANGE);
                setColorText(colors.WHITE);
            } else if (type === "cancel") {
                setColorBg(colors.WHITE);
                setColorBgHover(colors.WHITE);
                setColorText(colors.RED);
            } else {
                setColorBg(colors.MAIN_COLOR);
                setColorBgHover(colors.GREEN);
                setColorText(colors.WHITE);
            }
        }
    }, [props.type]);

    return (

        <Button
            ref={ref}
            variant="contained"
            disabled={disabled}

            sx={{
                backgroundColor: colorBg,
                color: colorText,

                '&:hover': {
                    backgroundColor: colorBgHover,
                    color: colorText
                }
            }}
            {...rest}
        >
            {children}
        </Button>
    );
});

ElevatedButton.propTypes = {
    children: PropTypes.node,
    disabled: PropTypes.bool,
    type: PropTypes.string,
};

export default ElevatedButton;